import { msg } from '@lingui/core/macro';
import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
export const TENANT_REQUEST_PATH = '/parceiros/solicitacoes';
export const tenantRequestPath = (id: string) => `${TENANT_REQUEST_PATH}/${encodeURIComponent(id)}`;
export const TENANT_REQUEST_TABS = [
  { id: 'baas', label: msg`BaaS`, icon: 'landmark' },
  { id: 'caas', label: msg`CaaS`, icon: 'file-text' },
  { id: 'billing', label: msg`Billing`, icon: 'receipt-text' },
] as const;
export const tenantRequestListSearch = listSearchSchema({});
export const tenantRequestDetailSearch = z.object({
  tab: z.enum(['baas', 'caas', 'billing']).optional().catch(undefined),
});
